import React, { useState, useEffect } from 'react';
import { SiteTitle } from "../SiteTitle";
import { Form, FormGroup, Label, Col, Button, Input, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DataTable from 'react-data-table-component';
import SelectTenableNet from "../BasicComponents/SelectTenableNet";
import SelectTenableUnit from "../BasicComponents/SelectTenableUnit";
import SelectTenableUrl from "../BasicComponents/SelectTenableUrl";
import { SelectName } from "../BasicComponents/SelectName";
import Swal from 'sweetalert2';

import { api_url } from "../globalFunction/global_string";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

function TenableResultResearch() {
    const [selectedNet, setSelectedNet] = useState('');
    const [localNetName, setLocalNetName] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('');
    const [localUnitName, setLocalUnitName] = useState('');
    const [selectedUrl, setSelectedUrl] = useState('');
    const [localUrlName, setLocalUrlName] = useState('');
    const [selectedUser, setSelectedUser] = useState('');
    const [localUserName, setLocalUserName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [hostPurpose, setHostPurpose] = useState('');
    const [hostOs, setHostOs] = useState('');
    const [formError, setFormError] = useState('');

    const [tableData, setTableData] = useState([]);
    const [historyData, setHistoryData] = useState({});

    const [totalSites, setTotalSites] = useState(0);
    const [expandedRows, setExpandedRows] = useState({});
    const [fileLoading, setFileLoading] = useState(false);
    const [heavyRiskSites, setHeavyRiskSites] = useState(0);
    const [highRiskSites, setHighRiskSites] = useState(0);
    const [mediumRiskSites, setMediumRiskSites] = useState(0);
    const [lowRiskSites, setLowRiskSites] = useState(0);
    const [messageRiskSites, setMessageRiskSites] = useState(0);

    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false); // 管理 Modal 開關狀態
    const [modalData, setModalData] = useState({});
    const [currentGuid, setCurrentGuid] = useState('');
    const [scanname, setScanname] = useState('');
    const [netName, setNetName] = useState(localStorage.getItem('login_user_net_name'));
    const [unitName, setUnitName] = useState(localStorage.getItem('login_local_unit_name'));

    const userType = localStorage.getItem('login_user_type');

    useEffect(() => {
        setStartDate(getLastYearDate());
        setEndDate(getTodayDate());
    }, []);

    const handleNetSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedNet(value);
        setLocalNetName(selectedName);
        setSelectedUnit('');
        setLocalUnitName('');
    };

    const handleUnitSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUnit(value);
        setLocalUnitName(selectedName);
    };

    const handleUrlSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUrl(value);
        setLocalUrlName(selectedName);
        console.log(value)
        console.log(selectedName)
    };

    // 處理人員選擇
    const handleUserSelectChange = (data) => {
        const { value, selectedName } = data;
        setSelectedUser(value);
        setLocalUserName(selectedName);
        console.log(value)
        console.log(selectedName)

    };


    const getTodayDate = () => {
        return new Date().toISOString().split('T')[0];
    };

    const getLastYearDate = () => {
        const today = new Date();
        today.setFullYear(today.getFullYear() - 1);
        return today.toISOString().split('T')[0];
    };

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (new Date(endDate) <= new Date(startDate)) {
            setFormError('結束日期必須大於開始日期');
            return;
        }

        setFormError('');
        fetchTableData();
    };

    const fetchTableData = () => {
        const formData = new FormData();
        formData.append("current_user_type", userType);

        switch (userType) {
            case 'S':
                formData.append("local_net_id", selectedNet);
                formData.append("local_unit_id", selectedUnit);
                formData.append("local_unit_name", localUnitName);
                formData.append("host_name", localUrlName);
                formData.append("starttime", startDate);
                formData.append("endtime", endDate);
                formData.append("host_purpose", hostPurpose);
                formData.append("host_os", hostOs);
                break;
            case 'M':
                formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
                formData.append("local_unit_id", selectedUnit);
                formData.append("local_unit_name", localUnitName);
                formData.append("host_name", localUrlName);
                formData.append("starttime", startDate);
                formData.append("endtime", endDate);
                formData.append("host_purpose", hostPurpose);
                formData.append("host_os", hostOs);
                break;
            case 'N':
                formData.append("local_net_id", localStorage.getItem('login_user_net_id'));
                formData.append("local_unit_id", localStorage.getItem('login_user_unit_id'));
                formData.append("local_unit_name", localStorage.getItem('login_local_unit_name'));
                formData.append("host_name", localUrlName);
                formData.append("starttime", startDate);
                formData.append("endtime", endDate);
                formData.append("host_purpose", hostPurpose);
                formData.append("host_os", hostOs);
                break;
            default:
                console.error("Unknown userType:", userType);
                return;
        }

        fetch(api_url + '/api/sche/GetTenableScan', {
            method: 'POST',
            body: formData,
            headers: {
                "Authorization": localStorage.getItem('accessToken')
            },
        })
            .then(response => response.json())
            .then(data => {
                if (!data || !Array.isArray(data.row)) {
                    console.error("Invalid data format or data.row is not an array:", data);
                    return;
                }

                const uniqueData = [];
                const historyData = {};

                data.row.forEach(row => {
                    const key = row.host_ip; // 使用 host_ip 作為唯一鍵

                    if (!historyData[key]) {
                        historyData[key] = []; // 初始化歷史記錄
                    }

                    // 將資料加入到歷史記錄中
                    historyData[key].push(row);

                    // 如果是 historyNumber === 1，則添加到 uniqueData
                    if (parseInt(row.historyNumber) === 1) {
                        uniqueData.push(row);
                    }
                });

                setTableData(uniqueData); // 顯示資料
                setHistoryData(historyData); // 設定歷史數據

                const totalSites = uniqueData.length;
                const heavyRiskSites = uniqueData.filter(row => row.heavy > "0").length;
                const highRiskSites = uniqueData.filter(row => row.heavy === "0" && row.high > "0").length;
                const mediumRiskSites = uniqueData.filter(row => row.heavy === "0" && row.high === "0" && row.meddle > "0").length;
                const lowRiskSites = uniqueData.filter(row => row.heavy === "0" && row.high === "0" && row.meddle === "0" && row.low > "0").length;
                const messageRiskSites = uniqueData.filter(row => row.heavy === "0" && row.high === "0" && row.meddle === "0" && row.low === "0" && row.message > "0").length;

                setTotalSites(totalSites);
                setHeavyRiskSites(heavyRiskSites);
                setHighRiskSites(highRiskSites);
                setMediumRiskSites(mediumRiskSites);
                setLowRiskSites(lowRiskSites);
                setMessageRiskSites(messageRiskSites);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    };



    const formatBuildDate = (date) => {
        return date.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");
    };


    const RiskHeader = ({ title, color }) => {
        return (
            <div style={{
                display: 'inline-block',
                backgroundColor: color,
                padding: '10px',
                borderRadius: '0px',
                color: 'white',
                margin: '0px'
            }}>
                {title}
            </div>
        );
    };


    // 下載報告
    const DownLoadPaper = async (scan_id) => {
        setFileLoading(true);
        const apiUrl = api_url + "/api/TEN/CheckAndDownloadReportAsync";
        const formData = new FormData();
        formData.append("scan_id", scan_id);

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Authorization": localStorage.getItem('accessToken')
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('API Response Data:', data);
            let arr_status = [String(data.statusCode), data.row, data.detail];
            const row = arr_status[1] !== null && arr_status[1] !== '' ? arr_status[1] : '';

            const regex = /\/[^\/]+\/[^\/]+\.zip/;
            const match = row.replace(/\\/g, '/').match(regex);
            const converted = match ? match[0] : '';

            console.log('Converted:', converted);

            const fileUrl = `${api_url}${converted}`;
            const fileResponse = await fetch(fileUrl);

            if (!fileResponse.ok) {
                throw new Error(`HTTP error! status: ${fileResponse.status}`);
            }

            const blob = await fileResponse.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;

            // 提取純檔案名稱
            const finalFileName = converted.substring(converted.lastIndexOf('/') + 1);
            console.log('Final FileName:', finalFileName);

            a.download = finalFileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error:', error);
        } finally {
            setFileLoading(false);
        }
    }




    const toggleRow = (rowId) => {
        setExpandedRows((prevExpandedRows) => ({
            ...prevExpandedRows,
            [rowId]: !prevExpandedRows[rowId], // 切換特定行的展開狀態
        }));
    };

    //打開歷史紀錄
    const showHistory = (row) => {
        const hostIp = row.host_ip; // 使用 host_ip 作為鍵
        if (!historyData[hostIp] || historyData[hostIp].length === 0) {
            console.warn("No history data available for host_ip:", hostIp);
            return;
        }

        const filteredRows = historyData[hostIp] || [];

        const sortedRows = filteredRows.sort((a, b) => Number(b.historyNumber) - Number(a.historyNumber));

        const sortedRowsJson = JSON.stringify(sortedRows);
        sessionStorage.setItem('CurrentHistoryData', sortedRowsJson);
    };

    //寄送密碼的MODAL內容
    const renderPasswordModalContent = () => {
        switch (userType) {
            case "S":
                return (
                    <>
                        <FormGroup row>
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7}>
                                <SelectTenableNet
                                    parentName={'superS'}
                                    id={'excel_net_name'}
                                    name={'excel_net_name'}
                                    requiredAPI={'/api/JRCC/GetLocalNetId'}
                                    handleNetSelectChange={handleNetSelectChange}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superS'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="local_user_id" sm={3} className="text-right">人員資料</Label>
                            <Col sm={7}>
                                <SelectName
                                    parentName={'superS'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectedUnitproxy={selectedUnit}
                                    local_unit_proxy_name={localUnitName}
                                    selectnet={selectedNet}
                                    local_net_name={localNetName}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                    </>
                );
            case "M":
                return (
                    <>
                        <FormGroup row>
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{netName}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7}>
                                <SelectTenableUnit
                                    parentName={'superM'}
                                    id={'excel_unit_name'}
                                    name={'excel_unit_name'}
                                    requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                    handleUnitSelectChange={handleUnitSelectChange}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={localStorage.getItem('login_user_net_name')}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row inline>
                            <Label for="local_user_id" sm={2}>人員資料</Label>
                            <Col sm={10}>
                                <SelectName
                                    parentName={'superM'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    selectedUnitproxy={selectedUnit}
                                    local_unit_proxy_name={localUnitName}
                                    selectnet={localStorage.getItem('login_user_net_id')}
                                    local_net_name={netName}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                    </>
                );
            case "N":
                return (
                    <>
                        <FormGroup row className="d-flex align-items-center">
                            <Label sm={3} className="text-right">區網名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{netName}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={3} className="text-right">單位名稱</Label>
                            <Col sm={7} className="d-flex align-items-center">
                                <p className="mb-0">{netName}</p>
                            </Col>
                        </FormGroup>
                        <FormGroup row inline>
                            <Label for="local_user_id" sm={2}>人員資料</Label>
                            <Col sm={10}>
                                <SelectName
                                    parentName={'superN'}
                                    id={'excel_user_name'}
                                    name={'excel_user_name'}
                                    requiredAPI={'/api/Async/GetUserdatalist'}
                                    handleUserSelectChange={handleUserSelectChange}
                                    style={{ width: '50%' }}
                                />
                            </Col>
                        </FormGroup>
                    </>
                );
            default:
                return <div>沒有可用的表單內容</div>;
        }
    };

    //寄送報告密碼
    const handleSendReportPassword = async () => {
        const apiUrl = `${api_url}/api/async/SendReportPaswword`;
        const formData = new FormData();

        // 根據不同的 userType 檢查輸入欄位
        if (userType === "S") {
            if (!selectedNet || !selectedUnit || !selectedUser) {
                Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
                return;
            }
        } else if (userType === "M") {
            if (!selectedUnit || !selectedUser) {
                Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
                return;
            }
        } else if (userType === "N") {
            if (!selectedUser) {
                Swal.fire("錯誤", "請選擇所有必要的選項。", "error");
                return;
            }
        }

        // 準備表單資料
        formData.append("send_user_id", localStorage.getItem('login_user_id'));
        formData.append("local_net_id", selectedNet);
        formData.append("local_unit_id", selectedUnit);
        formData.append("user_id", selectedUser);
        formData.append("currentGuid", modalData.id); // 使用 modalData 中的 id
        formData.append("scanname", modalData.scanname); // 使用 modalData 中的 scanname
        formData.append("net_name", modalData.net_name); // 使用 modalData 中的 net_name
        formData.append("unit_name", modalData.unit_name); // 使用 modalData 中的 unit_name
        formData.append("type", "TEN");
        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData,
            });

            const data = await response.json();

            if (data.statusCode === 200) {
                Swal.fire("成功", "報告密碼寄送成功。", "success");
                togglePasswordModal(); // 成功後關閉 Modal
            } else {
                Swal.fire("錯誤", "寄送失敗，請重試。", "error");
            }
        } catch (error) {
            console.log('Error fetching JSON:', error);
        }
    };

    const togglePasswordModal = () => {
        setIsPasswordModalOpen(!isPasswordModalOpen);
    };

    const handleShowPasswordModal = (id, scanname, net_name, unit_name) => {
        setModalData({ id, scanname, net_name, unit_name }); // 設定 Modal 需要的數據
        togglePasswordModal(); // 開啟 Modal
    };

    const StatusIndicator = ({ isTrackedreport }) => {
        let color;
        const numericIsTrackedreport = +isTrackedreport;

        switch (numericIsTrackedreport) {
            case 2:
                color = 'green';
                break;
            case 1:
                color = 'red';
                break;
            default:
                color = 'grey';
                break;
        }


        return (
            <div style={{
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                backgroundColor: color,
                display: 'inline-block',
            }} />
        );
    };

    const columns = [
        {
            name: '追蹤狀態',
            cell: row => (
                <StatusIndicator
                    isTrackedreport={row.isTrackedreport}
                />
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: '流水號',
            selector: row => {
                const newFormat = formatBuildDate(row.build_date);
                return `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
            },
            sortable: true,
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                }}>
                    {formatBuildDate(row.build_date)}-{row.local_net_id}-{row.local_unit_id}-{row.serial_no}
                </div>
            )
        },
        {
            name: '區網',
            selector: row => row.local_net_name,
            sortable: true,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    {row.local_net_name}
                </div>
            )
        },
        {
            name: '單位',
            selector: row => row.local_unit_name,
            sortable: true,
            cell: row => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                    {row.local_unit_name}
                </div>
            )
        },

        {
            name: '主機名稱',
            selector: row => row.host_name,
            sortable: true,
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                }}>
                    {row.host_name}
                </div>
            )
        },
        {
            name: '主機IP',
            selector: row => row.host_ip,
            sortable: true,
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                }}>
                    {row.host_ip}
                </div>
            )
        },
        { name: '狀態', selector: row => row.scan_status_description, sortable: true },
        { name: '主機用途', selector: row => row.host_purpose, sortable: true },
        {
            name: <RiskHeader title="重風險" color="purple" />,
            selector: row => row.heavy,
        },
        {
            name: <RiskHeader title="高風險" color="red" />,
            selector: row => row.high
        },
        {
            name: <RiskHeader title="中風險" color="orange" />,
            selector: row => row.meddle,
        },
        {
            name: <RiskHeader title="低風險" color="blue" />,
            selector: row => row.low,
        },
        {
            name: <RiskHeader title="訊息" color="green" />,
            selector: row => row.message,
        },
        { name: '建立人員', selector: row => row.build_id },
        {
            name: '操作',
            cell: row => {
                const isExpanded = expandedRows[row.scan_id] || false;
                const shouldShowHistoryButton = historyData[row.host_ip]?.length >= 1;
                const originalFormat = row.build_date;
                const newFormat = originalFormat.replace(/[/: ]/g, "");
                const scanname = `${newFormat}-${row.local_net_id}-${row.local_unit_id}-${row.serial_no}`;
                return (
                    <div>
                        {/* 下載報告按鈕 */}
                        {row.scan_status === "2" && row.downland_url && (
                            <Button type="button" className='btn btn-primary mx-1' onClick={() => DownLoadPaper(row.scan_id)}>下載報告</Button>
                        )}

                        {/* 展開/收起按鈕 */}
                        <Button type="button" className='btn btn-light mx-1' onClick={() => toggleRow(row.scan_id)}>
                            <FontAwesomeIcon icon={isExpanded ? faEyeSlash : faEllipsisV} size="2x" />
                        </Button>
                        {/* 附加操作按鈕 */}
                        {isExpanded && (
                            <>
                                {/* 歷史紀錄按鈕 */}
                                {shouldShowHistoryButton && (
                                    <Link
                                        to="/hostHistorypage"
                                        className='btn btn-secondary mx-1'
                                        onClick={() => showHistory(row)}
                                    >
                                        歷史紀錄
                                    </Link>
                                )}
                                {/* 寄送密碼 */}
                                {row.scan_status === "2" && row.downland_url && (
                                    <Button
                                        type="button"
                                        className="btn btn-secondary mx-1"
                                        onClick={() => handleShowPasswordModal(row.id, scanname, netName, unitName)}
                                    >
                                        寄送密碼
                                    </Button>
                                )}
                            </>
                        )}
                    </div>
                );
            },
            sortable: false,
        }
    ];

    let FormDataUI = null;

    switch (userType) {
        case "S":
            FormDataUI = (
                <Form onSubmit={handleSubmit}>
                    <FormGroup row>
                        <Label sm={3} className="text-right">區網名稱</Label>
                        <Col sm={7}>
                            <SelectTenableNet
                                parentName={'superS'}
                                id={'excel_net_name'}
                                name={'excel_net_name'}
                                requiredAPI={'/api/JRCC/GetLocalNetId'}
                                handleNetSelectChange={handleNetSelectChange}
                                style={{ width: '50%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                        <Col sm={7}>
                            <SelectTenableUnit
                                parentName={'superS'}
                                id={'excel_unit_name'}
                                name={'excel_unit_name'}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                handleUnitSelectChange={handleUnitSelectChange}
                                selectnet={selectedNet}
                                local_net_name={localNetName}
                                style={{ width: '50%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                        <Col sm={7}>
                            <SelectTenableUrl
                                parentName={'superS'}
                                id={'excel_unit_url'}
                                name={'excel_unit_url'}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                selectnet={selectedNet}
                                selectedUnit={selectedUnit}
                                local_net_name={localNetName}
                                local_unit_name={localUnitName}
                                onChange={handleUrlSelectChange}
                                style={{ width: '50%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for="startDate" sm={3} className="text-right">開始日期</Label>
                        <Col sm={7}>
                            <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                value={startDate}
                                max={getTodayDate()}
                                onChange={handleStartDateChange}
                                className="form-control"
                                style={{ width: '30%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for="endDate" sm={3} className="text-right">結束日期</Label>
                        <Col sm={7}>
                            <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                value={endDate}
                                min={startDate}
                                max={getTodayDate()}
                                onChange={handleEndDateChange}
                                className="form-control"
                                style={{ width: '30%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="host_purpose"
                                id="purpose"
                                value={hostPurpose}
                                onChange={(e) => setHostPurpose(e.target.value)}
                                style={{ width: '40%' }}
                            >
                                <option value="">請選擇</option>
                                <option value="A">個人電腦</option>
                                <option value="B">伺服器</option>
                                <option value="C">NAS</option>
                                <option value="D">IoT</option>
                                <option value="E">其他</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="host_os"
                                id="os"
                                value={hostOs}
                                onChange={(e) => setHostOs(e.target.value)}
                                style={{ width: '40%' }}
                            >
                                <option value="">請選擇</option>
                                <option value="A">Windows Series</option>
                                <option value="B">Windows Server Series</option>
                                <option value="C">MAC OS Series</option>
                                <option value="D">BSD Series</option>
                                <option value="E">Red Hat Series</option>
                                <option value="F">Debian Series</option>
                                <option value="G">Other OS</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 4, offset: 2 }}>
                            <Button
                                type="submit"
                                color="primary"
                                className="col-md-4 col-lg-3 mx-1 my-2"
                            >
                                查詢
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            );
            break;
        case "M":
            FormDataUI = (
                <Form onSubmit={handleSubmit}>
                    <FormGroup row className="d-flex align-items-center">
                        <Label sm={3} className="text-right">區網名稱</Label>
                        <Col sm={7} className="d-flex align-items-center">
                            <p className="mb-0">{netName}</p>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                        <Col sm={7}>
                            <SelectTenableUnit
                                parentName={'superM'}
                                id={'excel_unit_name'}
                                name={'excel_unit_name'}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                handleUnitSelectChange={handleUnitSelectChange}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={netName}
                                style={{ width: '50%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                        <Col sm={7}>
                            <SelectTenableUrl
                                parentName={'superS'}
                                id={'excel_unit_url'}
                                name={'excel_unit_url'}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                selectedUnit={selectedUnit}
                                local_net_name={netName}
                                local_unit_name={localUnitName}
                                onChange={handleUrlSelectChange}
                                style={{ width: '50%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for="startDate" sm={3} className="text-right">開始日期</Label>
                        <Col sm={7}>
                            <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                value={startDate}
                                max={getTodayDate()}
                                onChange={handleStartDateChange}
                                className="form-control"
                                style={{ width: '30%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for="endDate" sm={3} className="text-right">結束日期</Label>
                        <Col sm={7}>
                            <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                value={endDate}
                                min={startDate}
                                max={getTodayDate()}
                                onChange={handleEndDateChange}
                                className="form-control"
                                style={{ width: '30%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="host_purpose"
                                id="purpose"
                                value={hostPurpose}
                                onChange={(e) => setHostPurpose(e.target.value)}
                                style={{ width: '40%' }}
                            >
                                <option value="">請選擇</option>
                                <option value="A">個人電腦</option>
                                <option value="B">伺服器</option>
                                <option value="C">NAS</option>
                                <option value="D">IoT</option>
                                <option value="E">其他</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="host_os"
                                id="os"
                                value={hostOs}
                                onChange={(e) => setHostOs(e.target.value)}
                                style={{ width: '40%' }}
                            >
                                <option value="">請選擇</option>
                                <option value="A">Windows Series</option>
                                <option value="B">Windows Server Series</option>
                                <option value="C">MAC OS Series</option>
                                <option value="D">BSD Series</option>
                                <option value="E">Red Hat Series</option>
                                <option value="F">Debian Series</option>
                                <option value="G">Other OS</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 4, offset: 2 }}>
                            <Button
                                type="submit"
                                color="primary"
                                className="col-md-4 col-lg-3 mx-1 my-2"
                            >
                                查詢
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            );
            break;
        case "N":
            FormDataUI = (
                <Form onSubmit={handleSubmit}>
                    <FormGroup row className="d-flex align-items-center">
                        <Label sm={3} className="text-right">區網名稱</Label>
                        <Col sm={7} className="d-flex align-items-center">
                            <p className="mb-0">{netName}</p>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="excel_unit_name" sm={3} className="text-right">單位名稱</Label>
                        <Col sm={7} className="d-flex align-items-center">
                            <p className="mb-0">{unitName}</p>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="excel_unit_url" sm={3} className="text-right">主機名稱</Label>
                        <Col sm={7}>
                            <SelectTenableUrl
                                parentName={'superN'}
                                id={'excel_unit_url'}
                                name={'excel_unit_url'}
                                requiredAPI={'/api/JRCC/GetTenableHostip'}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                selectedUnit={localStorage.getItem('login_user_unit_id')}
                                local_net_name={netName}
                                local_unit_name={unitName}
                                onChange={handleUrlSelectChange}
                                style={{ width: '50%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for="startDate" sm={3} className="text-right">開始日期</Label>
                        <Col sm={7}>
                            <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                value={startDate}
                                max={getTodayDate()}
                                onChange={handleStartDateChange}
                                className="form-control"
                                style={{ width: '30%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for="endDate" sm={3} className="text-right">結束日期</Label>
                        <Col sm={7}>
                            <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                value={endDate}
                                min={startDate}
                                max={getTodayDate()}
                                onChange={handleEndDateChange}
                                className="form-control"
                                style={{ width: '30%' }}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="purpose" sm={3} className="text-right">主機用途</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="host_purpose"
                                id="purpose"
                                value={hostPurpose}
                                onChange={(e) => setHostPurpose(e.target.value)}
                                style={{ width: '40%' }}
                            >
                                <option value="">請選擇</option>
                                <option value="A">個人電腦</option>
                                <option value="B">伺服器</option>
                                <option value="C">NAS</option>
                                <option value="D">IoT</option>
                                <option value="E">其他</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="os" sm={3} className="text-right">主機作業系統</Label>
                        <Col sm={7}>
                            <Input
                                type="select"
                                name="host_os"
                                id="os"
                                value={hostOs}
                                onChange={(e) => setHostOs(e.target.value)}
                                style={{ width: '40%' }}
                            >
                                <option value="">請選擇</option>
                                <option value="A">Windows Series</option>
                                <option value="B">Windows Server Series</option>
                                <option value="C">MAC OS Series</option>
                                <option value="D">BSD Series</option>
                                <option value="E">Red Hat Series</option>
                                <option value="F">Debian Series</option>
                                <option value="G">Other OS</option>
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 4, offset: 2 }}>
                            <Button
                                type="submit"
                                color="primary"
                                className="col-md-4 col-lg-3 mx-1 my-2"
                            >
                                查詢
                            </Button>
                        </Col>
                    </FormGroup>
                </Form>
            );
            break;
        default:
            break;
    }

    return (
        <div>
            <SiteTitle />
            <div className="mt-5">
                <h1 id="tableLabel" className="mb-3">檢測主機結果查詢</h1>
                {FormDataUI}
            </div>
            <Row>
                <Col className="riskSummaryBox"><strong>總共主機數量: {totalSites}</strong></Col>
                <Col className="riskSummaryBox"><strong>重風險主機數量: {heavyRiskSites}</strong></Col>
                <Col className="riskSummaryBox"><strong>高風險主機數量: {highRiskSites}</strong></Col>
                <Col className="riskSummaryBox"><strong>中風險主機數量: {mediumRiskSites}</strong></Col>
                <Col className="riskSummaryBox"><strong>低風險主機數量: {lowRiskSites}</strong></Col>
                <Col className="riskSummaryBox"><strong>訊息風險主機數量: {messageRiskSites}</strong></Col>
            </Row>
            <DataTable
                columns={columns}
                data={tableData}
                pagination
                highlightOnHover
                noDataComponent="There are no records to display"
                persistTableHead
            />
            <Modal isOpen={isPasswordModalOpen} toggle={togglePasswordModal}>
                <ModalHeader toggle={togglePasswordModal}>寄送密碼</ModalHeader>
                <ModalBody>
                    {renderPasswordModalContent()}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSendReportPassword}>確認</Button>{' '}
                    <Button color="secondary" onClick={togglePasswordModal}>取消</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default TenableResultResearch;
